import Vue from 'vue'
import Router from 'vue-router'
import VueRouteMiddleware from 'vue-route-middleware'
import {UserRoute} from './user'
import {AdminRoute} from './admin'
import access from '../middleware/access'
import checkAuth from '../middleware/checkAuth'
import {ROLE_SUPER_USER, ROLE_USER} from '../helpers'

// import scormPackageAdmin from '@/components/Admin/scormPackageAdmin.vue'
// import CreateMediaFile from '@/components/Admin/CreateMediaFile.vue'

Vue.use(Router)

const routes = [
  {
    path: '/privacy',
    name: 'PrivacyPage',
    component: () => import('../pages/privacy')
  },
  {
    path: '/password',
    name: 'SetPassword',
    component: () => import('../components/Auth/password')
  },
  {
    path: '/forget-password',
    name: 'ForgetPassword',
    component: () => import('../components/Auth/ForgetPassword')
  },
  {
    path: '/user/meet',
    component: () => import('../components/User/Meet.vue')
  },
  {
    path: '',
    component: () => import('../components/router-view'),
    meta: { middleware: ['checkAuth'] },
    children: [
      {
        path: '/',
        name: 'Auth',
        component: () => import('../components/Auth/Auth.vue')
      },
      {
        path: '/eds-authorization',
        name: 'edsAuthorization',
        component: () => import('../components/Auth/edsAuthorization.vue')
      }
    ]
  },
  {
    path: '',
    component: () => import('../components/router-view'),
    meta: { middleware: ['access'] },
    children: [
      {
        path: '/user',
        component: () => import('../components/User/User.vue'),
        redirect: '/user/video-lesson',
        children: UserRoute
      },
      {
        path: '/admin',
        component: () => import('../components/Admin/Admin.vue'),
        redirect: '/admin/statistics',
        children: AdminRoute
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return new Promise(resolve => {
      if (savedPosition) resolve(savedPosition)
      else resolve({ x: 0, y: 0 })
    })
  }
})

router.beforeEach(
  VueRouteMiddleware({
    access,
    checkAuth
  })
)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js